import React from "react";
import { Tag } from "@appsmith/ads";

function BetaCard() {
  return (
    <Tag isClosable={false} size="md">
      Beta
    </Tag>
  );
}

export default BetaCard;
